import NeonHero from '../../components/NeonHero';
import FinancingBanner from '../../components/FinancingBanner';

export default function Suspension() {
	return (
		<div>
			<NeonHero
				title="Suspension & Alignment"
				subtitle="Precision steering and ride quality. AI-calibrated alignment and component replacement."
				primaryCta={{ label: 'Schedule Alignment', href: 'https://realm.ubiquityauto.com/order/2dcf3188-0a07-4444-b5f8-065a5dc238bb?access_token=_ha6LYxaO-9HjbYZVCY7P21vuKFFRaQ5' }}
			/>

			<FinancingBanner />

			<section className="container py-12">
				<h2 className="text-2xl font-bold">Services</h2>
				<ul className="mt-4 grid sm:grid-cols-2 gap-3 text-gray-700 list-disc list-inside">
					<li>Struts, shocks, control arms, ball joints</li>
					<li>Wheel bearings, tie rods, bushings</li>
					<li>Lift, level, and lowering kits</li>
					<li>Computerized alignment & road force balancing</li>
				</ul>
				<div className="mt-10 grid md:grid-cols-3 gap-6">
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Process</h3>
						<ol className="mt-2 list-decimal list-inside text-gray-700 space-y-1">
							<li>Inspection and play tests</li>
							<li>Component replacement and torque spec</li>
							<li>Alignment and calibration</li>
							<li>Road test and report</li>
						</ol>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Financing</h3>
						<p className="mt-2 text-gray-700">Drive Now, Pay Later: Affirm and Klarna available at checkout.</p>
					</div>
					<div className="rounded-xl border bg-white p-6 shadow-sm">
						<h3 className="font-semibold">Timeline</h3>
						<p className="mt-2 text-gray-700">Most jobs 1 day; lift kits vary 1–2 days depending on configuration.</p>
					</div>
				</div>
			</section>
		</div>
	);
}
